/**
 * Thin wrapper for Dejavoo / Freedom To Design browser SDK integration.
 *
 * This service does not implement the actual SDK calls yet; instead, it
 * provides a single, well-defined entrypoint that can be wired to the
 * official Dejavoo JS SDK or hosted integration when available.
 */
class DejavooSdkService {
  /**
   * Start a Dejavoo CNP transaction using SDK/JS integration.
   *
   * @param {object} config - Dejavoo session config from backend:
   *   { amountMinor, currency, mid, tpn, ftdMode, gpayMerchantId, gpayMode }
   * @param {object} context - Extra context (e.g. tabId, tabPaymentId) for logging/tracking.
   * @returns {Promise<object>} - Expected to resolve with a provider-specific result
   *   shape once the real SDK is integrated (e.g. { status, token, gatewayRef }).
   */
  async pay (config, context = {}) {
    if (!config) {
      throw new Error('Missing Dejavoo session configuration')
    }

    // Placeholder implementation: real integration should delegate to the
    // official Dejavoo/FTD JS SDK or hosted checkout bridge.
    if (typeof window !== 'undefined' && window.DejavooFTD && typeof window.DejavooFTD.startCnp === 'function') {
      return window.DejavooFTD.startCnp({
        amountMinor: config.amountMinor,
        currency: config.currency,
        mid: config.mid,
        tpn: config.tpn,
        ftdMode: config.ftdMode,
        gpayMerchantId: config.gpayMerchantId,
        gpayMode: config.gpayMode,
        context
      })
    }

    // Until the SDK is wired, surface a clear error so operators know why
    // the flow cannot proceed.
    throw new Error('Dejavoo SDK is not available in this environment')
  }
}

export default new DejavooSdkService()


